import { motion, useReducedMotion } from 'framer-motion'

function AnimatedSection({
  children,
  className = '',
  delay = 0,
  as = 'section',
  animate = true,
  ...props
}) {
  const prefersReducedMotion = useReducedMotion()
  const Tag = as

  if (!animate || prefersReducedMotion) {
    return (
      <Tag className={className} {...props}>
        {children}
      </Tag>
    )
  }

  const Component = motion[as]

  return (
    <Component
      className={className}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.05, margin: '0px 0px -60px 0px' }}
      transition={{ duration: 0.45, ease: 'easeOut', delay }}
      {...props}
    >
      {children}
    </Component>
  )
}

export default AnimatedSection
